import { getDateMoment, getDateMoment360 } from '../helper';
/* eslint-disable global-require */
const List = () => import(/* webpackChunkName: "autorizacao-bundle" */ './main.vue');
const Search = () => import(/* webpackChunkName: "autorizacao-bundle" */ './search.vue');

export default [
  {
    name: 'auditoria-odontologica',
    path: '/auditoria-odontologica',
    components: { default: List, search: Search },
    meta: {
      requiresAuth: true,
      breadcrum: 'Odontológica',
      icon: 'tooth',
      can: 'list',
      on: 'auditoria',
    },
    beforeEnter(to, from, next) {
      if (!to.query.inicio) {
        next({
          name: 'auditoria-odontologica',
          query: {
            inicio: getDateMoment360(),
            termino: getDateMoment(),
            statusAutorizacao: 'Em Análise',
          },
        });
      } else {
        next();
      }
    },
  },
];
